import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import PrimaryBtn from '../../Resources/Buttons/PrimaryBtn'
import classes from './VariantTable.module.css'

const VariantTable = ({ variants, product }) => {
    return (
        <Fragment>
            {variants.length > 0 && (
                <Fragment>
                    <div className={classes.productTable}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Cost of Product</th>
                                    {
                                        <Fragment>
                                            <th>Retail Price</th>
                                            <th>Discount (%) Retail Price</th>
                                            <th>Retail Price After Discount</th>
                                        </Fragment>
                                    }
                                    {
                                        <Fragment>
                                            <th>Wholesale Price</th>
                                            <th>Discount (%) Wholesale Price</th>
                                            <th>Wholesale Price After Discount</th>
                                        </Fragment>
                                    }
                                    <th>Product Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {variants?.map((variant, index) => {
                                    const {
                                        variant_type,
                                        variant_value,
                                        variant_type2,
                                        variant_value2,
                                        manufacture_cost,
                                        retail_price,
                                        retail_discount_percentage,
                                        final_retail_price,
                                        wholesale_price,
                                        wholesale_discount_percentage,
                                        final_wholesale_price,
                                        quantity,
                                    } = variant
                                    return (
                                        <tr key={index}>
                                            <td>
                                                {variant_value} {variant_type2 && ` | ${variant_value2}`}
                                            </td>
                                            <td>
                                                <input type="number" value={manufacture_cost} disabled={true} />
                                            </td>
                                            {
                                                <>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            value={retail_price || 0}
                                                            disabled={true}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className={classes.input}
                                                            value={retail_discount_percentage || 0}
                                                            disabled={true}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input type="number" value={final_retail_price || 0} disabled />
                                                    </td>
                                                </>
                                            }
                                            {
                                                <>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            value={wholesale_price || 0}
                                                            disabled={true}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className={classes.input}
                                                            value={wholesale_discount_percentage || 0}
                                                            disabled={true}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            value={final_wholesale_price || 0}
                                                            disabled
                                                        />
                                                    </td>
                                                </>
                                            }
                                            <td>
                                                <input type="number" value={quantity} name="quantity" disabled />
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className={classes.footerWrapper}>
                        {variants.reduce((total, variant) => total + variant.quantity, 0) > 0 && (
                            <div className={classes.footer}>
                                <p className="total">
                                    Total Product Quantity :
                                    <span> {variants.reduce((total, variant) => total + variant.quantity, 0)}</span>
                                </p>
                            </div>
                        )}

                        <Link to={`/products/edit/${product.id}/variant`} target="_blank" rel="noopener noreferrer">
                            <PrimaryBtn label={'Edit'} />
                        </Link>
                    </div>
                </Fragment>
            )}
        </Fragment>
    )
}

export default VariantTable
